//[IMPORT] Sub mixins module
import commonMixin  from './urCommonGridMixin';
import rowActMixin  from './full/urFullGridRowActMixin';
import sortMixin    from './full/urFullGridSortMixin';

import {getKey, isNull} from '../util';
import {CONST} from '../config';


export default {
    mixins: [commonMixin, rowActMixin, sortMixin],
    data() {return {
        mx_gridData  : [],
        mx_viewData  : [],
        mx_dataMap   : new Map(),
        
        vars_accordionRow : null,
    }},
    computed : {
        // [COPMUTED][VARS] Data size
        vars_dataSize() {
            if(this.itemSize) {
                return this.itemSize;
            }
            if(!isNull(this.mx_options.grouping)) {
                return this.mx_gridData.reduce((acc, row)=>acc+row.chLen,0);
            }
            return this.mx_gridData?this.mx_gridData.length:0;
        },
        // [COPMUTED][VARS] View size
        vars_viewSize() {
            if(!isNull(this.mx_options.grouping)) {
                return this.mx_viewData.reduce((acc, row)=>acc+row.chLen,0);
            }
            return this.mx_viewData?this.mx_viewData.length:0;
        }
    },
    watch : {
        "items.length" : function() {
            /*TEST CODE*/console.debug('[FULL] watch.items.length :',this.__i14=1+(this.__i14||0));
            // 배열이 변경되지 않은채 items 길이만 변경된 경우.
            this.mx_initData();
        },
        items : {immediate: true, handler(v,w) {
            // TODO 이거 막 중간에 값만 갈아끼워도 타는거 같은데? 확인필요 
            /*TEST CODE*/console.debug('[FULL] watch.items :',this.__i11=1+(this.__i11||0));
            if(!v) {return}
            // 1. check is it changed?
            if(v===w) {
                // XXX 순서만 바꾼경우? -> 안쪽에 객체는 바인딩 되어있으니까 안에서 해주겠지
                if(v.length === w.length) {return;}
            } else {
                // 3. reset dirty data
                this.mx_created = [];
                this.mx_updated = [];
                this.mx_removed = [];
            }
            // 2. Check length and warning
            if(v.length > 100) {
                console.warn('[UIDev] Data is too many for full-grid. ('+v.length+')');
            }
            // 3. Check length and warning
            this.mx_initData();
            // X. Send Event
            this.mx_fireEvent('data-changed',this.mx_getChanged());
        }},
    },
    beforeCreate() {
        /*TEST CODE*/console.debug('[FULL] beforeCreate :',this.__i01=1+(this.__i01||0));
    },
    created() {
        /*TEST CODE*/console.debug('[FULL] created :'     ,this.__i02=1+(this.__i02||0));
    },
    beforeMount() {
        /*TEST CODE*/console.debug('[FULL] beforeMount :' ,this.__i03=1+(this.__i03||0));
    },
    mounted() {
        /*TEST CODE*/console.debug('[FULL] mounted :'     ,this.__i04=1+(this.__i04||0));
    },
    beforeUpdate() {
        /*TEST CODE*/console.debug('[FULL] beforeUpdate :',this.__i05=1+(this.__i05||0));
    },
    updated() {
        /*TEST CODE*/console.debug('[FULL] updated :'     ,this.__i06=1+(this.__i06||0));
    },
    methods : {
        // [METHOD][DATA] Initialize all data
        mx_initData() {
            /*TEST CODE*/console.debug('[FULL] methods.mx_initData['+this.items.length+'] :',this.__i31=1+(this.__i31||0));
            // 1. set init flag
            this.mx_dataMap.clear()
            for(var i=0, ii=this.items.length; i<ii ; i++) {
                this.mx_initItem(this.items[i], i)
                this.mx_dataMap.set(this.items[i].__id, this.items[i])
            }
            // 2. make mx_gridData -> shallow copy
            this.mx_buildData();
        },
        // [METHOD][DATA] Initialize row data for grid
        mx_initItem(r, i) {
            // __id : 해당 row의 식별자
            if(!r.__id) {
                this.$set(r,'__id', getKey(`grid${this._uid}`));
            }
            // __idx : 단순 row의 index :: 로직에 절대로 쓰지 말것
            this.$set(r,'__idx', i);
            // __hover : 마우스가 올라가있슴니까? -> 스크립트로 Mouseover 제어함
            if(!r.hasOwnProperty('__hover'))    {this.$set(r,'__hover', false)}
            // __dirty : 수정되었습니까? TODO 개발해야됨
            if(!r.hasOwnProperty('__dirty'))    {this.$set(r,'__dirty', null)}
            // __selected : 선택되었습니까?
            if(!r.hasOwnProperty('__selected')) {this.$set(r,'__selected', false)}
            // __focused : 행 포커스 여부
            if(!r.hasOwnProperty('__focused'))  {this.$set(r,'__focused', null)}
            // __editMode : 수정되었습니까? - Row edit mode
            if(!r.hasOwnProperty('__editMode')) {this.$set(r,'__editMode', false)}
            // __editMode : 수정되었습니까? - Cell edit mode
            if(!r.hasOwnProperty('__editField')){this.$set(r,'__editField', null)}
            // __errMsg : 에러 메시지
            if(!r.hasOwnProperty('__errMsg'))   {this.$set(r,'__errMsg', null)}
            // __accordion : 아코디언 열어주세요. 음.. 안쓸땐 안하면 좋겠다.
            if(!r.hasOwnProperty('__accordion')){this.$set(r,'__accordion', false)}
        },
        // [METHOD][DATA] Copy data from origin to mx_gridData
        mx_buildData() {
            /*TEST CODE*/console.debug('[FULL] methods.buildData['+this.items.length+'] :',this.__i32=1+(this.__i32||0));
            // 1. Set to mx_gridData
            var grps = this.mx_options.grouping;
            if(Array.isArray(grps) && grps.length) {
                this.mx_gridData = this.mx_buildData_group(this.items);
            } else {
                this.mx_gridData = this.mx_buildData_default(this.items);
            }
            this.mx_buildViewData();
            // x. Unset something..
            this.mx_toggleEditCancel(); 
        },
        // [LOCAL][DATA] build default
        mx_buildData_default(oriArr) {
            var arr;
            // 1. Copy data from origin
            arr = oriArr.slice();
            // 2. Filter first
            //    mxFullGridFilterMixin.js
            if(!this.mx_options.externalFilter) {
                arr = this.mx_filterData(arr);
            }
            // 3. Sort is second
            //    urFullGridSortMixin.js
            if(!this.mx_options.externalSort) {
                arr = this.mx_sort_sortData(arr)
            }
            // x. Do something..
            if(this.mx_options.cellMode) {
                this.mx_clearCellSelect();
            }
            return arr;
        },
        // [LOCAL][DATA] Get instance group object
        mx_newGroupObj(v, i) {
            return {
                group : true,
                value : v    , depth : i,
                children : [], chMap : new Map(), chLen : 0,
                leaf  : false, expand: true,
                __st : 0     , __ed: 0
            }
        },
        // [LOCAL][DATA] Build group data
        mx_buildData_group(oriArr) {
            var grps = this.mx_options.grouping;
            var arr = [], me = this,
                rootMap = new Map(); // rootMap -> 버리기 아까운데?
            // 1. split data(from data origin)
            oriArr.forEach(row => {
                var obj = {children:arr, chMap:rootMap};
                grps.forEach((grp,i) => {
                    var v = row[grp];
                    if(obj.chMap.has(v)) {
                        obj = obj.chMap.get(v);
                    } else {
                        var nue = this.mx_newGroupObj(v,i);
                        obj.children.push(nue);
                        obj.chMap.set(v, nue);
                        obj = nue;
                    }
                })
                // 1.x Found target object(group)
                obj.leaf = true
                obj.children.push(row);
            })
            
            // 2. re-build tree -> sort/filter
            arr = (function subArr(origin, depth, _offset) { // recursive
                var offset = _offset;
                var grps = me.mx_options.grouping;
                var f = me.mx_fieldMap.get(grps[depth]);
                var arr = origin.slice();
                // 1. Calc this.
                // 1.1 Filter me
                if(!isNull(f.__filterValue)) {
                    arr = arr.filter(grp => { // urCommonGridFilterMixin.js
                        return me.mx_filter_getChecker(f)(grp.value, f.__filterValue);
                    })
                }
                // 1.2 Sort me
                if(f.__sortOrder) {
                    arr.sort((x,y) => me.mx_sort_comparator(f,x,y,'value'))
                }
                // 1.x And iter children..
                arr.forEach(o=>{
                    if(o.group) {
                        if(o.leaf) {
                            o.children = me.mx_buildData_default(o.children);
                            o.chLen = o.children.length;
                        } else {
                            o.children = subArr(o.children, depth+1, offset);
                            o.chLen = o.children.reduce((acc, ch)=>acc+ch.chLen,0);
                        }
                    }
                })
                return arr;
            })(arr, 0, 0);
            // 3. indexing offset
            this.mx_buildGroupTreeOffset(arr,0);
            
            return arr;
        },
        // [LOCAL][DATA] Build Tree offset
        mx_buildGroupTreeOffset(_arr, _offset){
            if(_offset === 0) {
                /*TEST CODE*/console.debug('[FULL] methods.buildGroupTreeOffset :',this.__i33=1+(this.__i33||0));
            }
            var arr = _arr || this.mx_gridData,
                offset = _offset || 0;
            var rh = this.mx_options.rowHeight;
            var isVertAcc = this.mx_options.accordionVertical>0 || !!this.vars_freezeWidth;
            var gh = this.mx_options.groupHeader ? this.mx_options.groupRowHeight : 0;
            var sh = this.mx_options.groupSummary? this.mx_options.groupSummaryHeight : 0;
            arr.forEach(o=>{
                o.__st = offset;
                if(o.group) {
                    offset += gh + sh
                    if(o.leaf&&o.expand) {
                        offset += o.children.reduce((acc,row)=> {
                            var accHeight = !isVertAcc&&row.__accordion?row.__accordionHeight||0:0
                            return acc + accHeight + rh;
                        },0);
                    } else if(o.expand) {
                        offset = this.mx_buildGroupTreeOffset(o.children, offset)
                    }
                }
                o.__ed = offset-(offset===o.__st?0:1);
            })
            return offset;
        },
        // [METHOD][DATA] build view data
        mx_buildViewData() {
            if(this.mx_options.internalPaging) {
                var pager=this.mx_pager;
                var st = pager.firstIndex
                  , ed = Math.min(st + pager.rowsPerPage,this.mx_gridData.length);
                this.mx_viewData = this.mx_gridData.slice(st,ed);
            } else {
                this.mx_viewData = this.mx_gridData.slice();
            }
        },
        // [METHOD][DATA] Get build data
        mx_getViewData() {
            return this.mx_viewData;
        },
        // [METHOD][DATA] Set value for full/data grid logic sync
        mx_setValue(row, fieldKey, value) {
            // 1. check
            if(!row) return null;
            // 2. set value
            row[fieldKey] = value;
            // 3. dirty?
            if(!row.__dirty && (fieldKey[0]!=='_'||fieldKey[1]!=='_')) { // !field.startsWith('__')
                row.__dirty = CONST.VAL.DIRTY.FLAG.UPDATE;
                this.mx_updated.push(row);
            }
            return value
        },
        // [METHOD][DATA] Get row with rowId.
        mx_getRow(rowId) {
            return this.mx_dataMap.get(rowId)
        },
        // [METHOD] Open context menu
        mx_openAccordion(row, value) {
            // 1. Close previous
            if(this.vars_accordionRow) { // open multiple?
                this.mx_setValue(this.vars_accordionRow, '__accordion', false)
            }
            // 2. Open next
            this.mx_setValue(row, '__accordion', value)
            this.vars_accordionRow = value ? row:null;
        },
    }
}